import React from 'react'
import { isAccessAllowed } from '../dashboard/hooks/userHooks'

export function ShowForAllowedPermissionsOnly({ toCheck = [], children }) {
    return isAccessAllowed(toCheck) ? children : null
}